if (!customElements.get('ae-marantz')) {
  customElements.define('ae-marantz', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-marantz-interest]');
        if (!trigger) return;
        const select = this.querySelector('#MarantzInterest');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.value === trigger.dataset.marantzInterest);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}




